import classNames from 'classnames';
import { ValidationError } from '../../../../../../components/validation-error/validation-error';

export const OffRentValidationError = ({ orderValidationMessages }: { orderValidationMessages: string[] }) => {
  return (
    <ValidationError
      className={classNames({ hidden: orderValidationMessages.length === 0 })}
      style={{ maxWidth: '342px' }}
    >
      <ul>
        {orderValidationMessages.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    </ValidationError>
  );
};
